// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Dashboard - Enterprise Corporate Design
   ============================================ */

/* CSS Variables - Matching Theme */
:root {
  --dashboard-bg: #f8f9fa;
  --dashboard-text: #000000;
  --dashboard-text-muted: #4a5568;
  --dashboard-border: rgba(135, 206, 235, 0.3);
  --light-sky-blue: #87ceeb;
  --light-red: #ff6b6b;
  --white: #ffffff;
  --transition: all 0.2s ease;
}

/* ============================================
   Main Dashboard Container
   ============================================ */
.Dashboard_dashboard__RDdb6 {
  min-height: calc(100vh - 60px);
  background: var(--dashboard-bg);
  padding: 1.5rem;
  color: var(--dashboard-text);
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* ============================================
   Dashboard Header
   ============================================ */
.Dashboard_dashboardHeader__zb7AE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.Dashboard_dashboardTitle__BDJEW {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--dashboard-text);
  margin: 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.Dashboard_timeDisplay__EYu7z {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--dashboard-text-muted);
  padding: 0.5rem 1rem;
  background: var(--white);
  border: 1px solid var(--dashboard-border);
  border-radius: 0.375rem;
}

.Dashboard_timeDisplay__EYu7z svg {
  color: var(--light-sky-blue);
  flex-shrink: 0;
}

/* ============================================
   Error Alert
   ============================================ */
.Dashboard_errorAlert__iIXGN {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--light-red);
  color: white;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.Dashboard_errorAlert__iIXGN svg {
  flex-shrink: 0;
}

/* ============================================
   Loading Container
   ============================================ */
.Dashboard_loadingContainer__ss\\+Te {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.Dashboard_spinner__bdpNT {
  color: var(--light-sky-blue);
  animation: Dashboard_spin__gW-XO 1s linear infinite;
}

@keyframes Dashboard_spin__gW-XO {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* ============================================
   Metrics Grid
   ============================================ */
.Dashboard_metricsGrid__nDn\\+t {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.Dashboard_metricCard__Tz84A {
  background: var(--white);
  border: 1px solid var(--dashboard-border);
  border-radius: 0.5rem;
  padding: 1.25rem;
  transition: var(--transition);
}

.Dashboard_metricCard__Tz84A:hover {
  border-color: var(--light-sky-blue);
  transform: translateY(-2px);
}

.Dashboard_metricCardClickable__Qi503 {
  cursor: pointer;
}

.Dashboard_metricCardClickable__Qi503:hover {
  box-shadow: 0 4px 12px rgba(135, 206, 235, 0.25);
}

.Dashboard_metricCardClickable__Qi503:focus-visible {
  outline: 2px solid var(--light-sky-blue);
  outline-offset: 2px;
}

.Dashboard_metricContent__ONC4m {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Dashboard_metricInfo__PoTXc {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1 1;
}

.Dashboard_metricLabel__2hG1u {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--dashboard-text-muted);
}

.Dashboard_metricValue__oODCO {
  font-size: 2rem;
  font-weight: 700;
  color: var(--dashboard-text);
  line-height: 1.2;
}

.Dashboard_metricIcon__leoQq {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  flex-shrink: 0;
  background: rgba(135, 206, 235, 0.1);
  color: var(--light-sky-blue);
}

/* ============================================
   Top Cards Container (Activity Log & Upcoming Draws)
   ============================================ */
.Dashboard_topCardsContainer__bZdVl {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

/* ============================================
   Player Status Container (Full Width)
   ============================================ */
.Dashboard_playerStatusContainer__D03Oz {
  width: 100%;
  margin-bottom: 1.5rem;
}

/* ============================================
   Info Grid
   ============================================ */
.Dashboard_infoGrid__BaEMr {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.Dashboard_infoCard__yM6ta {
  background: var(--white);
  border: 1px solid var(--dashboard-border);
  border-radius: 0.5rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  transition: var(--transition);
  flex: 1 1;
  min-width: 300px;
  overflow: hidden;
}

.Dashboard_infoCardFullWidth__-zSsL {
  width: 100%;
  min-width: 100%;
}

.Dashboard_infoCard__yM6ta:hover {
  border-color: var(--light-sky-blue);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.Dashboard_infoCardTitle__7VdQr {
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: none;
}

.Dashboard_infoCardIcon__hMSmu {
  flex-shrink: 0;
  color: #ffffff;
  opacity: 0.9;
}

.Dashboard_infoCardTitleBlack__R7uw8 {
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  color: #ffffff;
}

.Dashboard_infoCardTitleNavy__FspgZ {
  background: linear-gradient(135deg, #001f3f 0%, #000000 50%, #001f3f 100%);
  color: #ffffff;
}

.Dashboard_infoCardContent__oIJNv {
  padding: 1.25rem;
}

/* ============================================
   Activity Log
   ============================================ */
.Dashboard_activityList__lhNy7 {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.Dashboard_activityRow__SJkzP {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
}

.Dashboard_activityLabel__dP-Z- {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--dashboard-text-muted);
}

.Dashboard_activityValue__MaCVD {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--dashboard-text);
}

/* ============================================
   Upcoming Draws
   ============================================ */
.Dashboard_drawsList__g9Pp5 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.Dashboard_drawRow__Ru\\+bF {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--dashboard-border);
}

.Dashboard_drawRow__Ru\\+bF:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.Dashboard_drawInfo__FgwbD {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1 1;
}

.Dashboard_drawGameName__9yLmy {
  font-size: 1rem;
  font-weight: 700;
  color: var(--dashboard-text);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.Dashboard_drawSeparator__jvbBF {
  color: var(--dashboard-text);
  font-weight: 400;
}

.Dashboard_drawId__DjYWM {
  font-size: 0.875rem;
  font-weight: 700;
  color: #000000;
  background: rgba(0, 255, 0, 0.3);
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  display: inline-block;
}

.Dashboard_drawTime__1bL9A {
  font-size: 1rem;
  font-weight: 600;
  color: var(--dashboard-text);
}

.Dashboard_emptyState__4Z9zs {
  font-size: 0.875rem;
  color: var(--dashboard-text-muted);
  text-align: center;
  padding: 1rem 0;
}

/* ============================================
   Player Status
   ============================================ */
.Dashboard_playerStatus__9Iyxs {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.Dashboard_totalPlayers__DGtTw {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.Dashboard_totalLabel__pwYiN {
  font-size: 0.875rem;
  color: var(--dashboard-text-muted);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.Dashboard_totalValue__2L7gP {
  font-size: 2rem;
  font-weight: 700;
  color: var(--dashboard-text);
  line-height: 1.2;
}

.Dashboard_statusList__qf4yt {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.Dashboard_statusRow__gGU6l {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
  font-size: 0.875rem;
}

.Dashboard_statusLabel__kvkVW {
  color: var(--dashboard-text);
  font-weight: 500;
}

.Dashboard_statusValue__ilYsS {
  font-weight: 700;
  color: var(--dashboard-text);
}

.Dashboard_breakdown__B9PZr {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-top: 0.75rem;
  margin-top: 0.75rem;
}

.Dashboard_breakdownDivider__HdUad {
  height: 1px;
  background: var(--dashboard-border);
}

.Dashboard_breakdownTitle__dgql3 {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--dashboard-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* ============================================
   Responsive Design - Tablet
   ============================================ */
@media (max-width: 1024px) {
  .Dashboard_dashboard__RDdb6 {
    padding: 1.25rem;
  }

  .Dashboard_dashboardTitle__BDJEW {
    font-size: 1.25rem;
  }

  .Dashboard_metricsGrid__nDn\\+t {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 0.875rem;
  }

  .Dashboard_topCardsContainer__bZdVl {
    flex-direction: column;
    gap: 0.875rem;
  }

  .Dashboard_infoCard__yM6ta {
    min-width: 100%;
  }

  .Dashboard_totalValue__2L7gP {
    font-size: 1.75rem;
  }

  .Dashboard_metricValue__oODCO {
    font-size: 1.75rem;
  }
}

/* ============================================
   Responsive Design - Mobile
   ============================================ */
@media (max-width: 768px) {
  .Dashboard_dashboard__RDdb6 {
    padding: 1rem;
    min-height: calc(100vh - 50px);
  }

  .Dashboard_dashboardHeader__zb7AE {
    margin-bottom: 1.25rem;
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
  }

  .Dashboard_dashboardTitle__BDJEW {
    font-size: 1.125rem;
    flex: 1 1;
    min-width: 0;
  }

  .Dashboard_timeDisplay__EYu7z {
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
    flex-shrink: 0;
    white-space: nowrap;
  }

  .Dashboard_metricsGrid__nDn\\+t {
    grid-template-columns: 1fr;
    gap: 0.75rem;
    margin-bottom: 1.25rem;
  }

  .Dashboard_topCardsContainer__bZdVl {
    flex-direction: column;
    gap: 0.75rem;
  }

  .Dashboard_playerStatusContainer__D03Oz {
    width: 100%;
  }

  .Dashboard_totalValue__2L7gP {
    font-size: 1.5rem;
  }

  .Dashboard_metricCard__Tz84A {
    padding: 1rem;
    width: 100%;
    box-sizing: border-box;
  }

  .Dashboard_infoCard__yM6ta {
    padding: 1rem;
    width: 100%;
    box-sizing: border-box;
  }

  .Dashboard_metricValue__oODCO {
    font-size: 1.5rem;
  }

  .Dashboard_totalValue__2L7gP {
    font-size: 1.75rem;
  }

  .Dashboard_drawRow__Ru\\+bF {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .Dashboard_drawTime__1bL9A {
    width: 100%;
    text-align: right;
  }
}

/* ============================================
   Responsive Design - Small Mobile
   ============================================ */
@media (max-width: 480px) {
  .Dashboard_dashboard__RDdb6 {
    padding: 0.75rem;
    min-height: calc(100vh - 48px);
  }

  .Dashboard_dashboardHeader__zb7AE {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .Dashboard_dashboardTitle__BDJEW {
    font-size: 1rem;
    width: 100%;
  }

  .Dashboard_timeDisplay__EYu7z {
    width: 100%;
    justify-content: center;
  }

  .Dashboard_metricCard__Tz84A {
    padding: 0.875rem;
    width: 100%;
    box-sizing: border-box;
  }

  .Dashboard_metricContent__ONC4m {
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  .Dashboard_metricIcon__leoQq {
    width: 48px;
    height: 48px;
  }

  .Dashboard_metricIcon__leoQq svg {
    width: 24px;
    height: 24px;
  }

  .Dashboard_metricValue__oODCO {
    font-size: 1.375rem;
  }

  .Dashboard_infoCard__yM6ta {
    padding: 0.875rem;
    width: 100%;
    box-sizing: border-box;
  }

  .Dashboard_infoCardTitle__7VdQr {
    font-size: 0.875rem;
  }

  .Dashboard_drawGameName__9yLmy {
    font-size: 0.875rem;
  }

  .Dashboard_drawTime__1bL9A {
    font-size: 0.875rem;
  }

  .Dashboard_totalValue__2L7gP {
    font-size: 1.5rem;
  }

  .Dashboard_drawRow__Ru\\+bF {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .Dashboard_drawTime__1bL9A {
    width: 100%;
    text-align: left;
  }
}

/* ============================================
   Accessibility
   ============================================ */
@media (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}

/* Print styles */
@media print {
  .Dashboard_dashboard__RDdb6 {
    background: white;
  }

  .Dashboard_metricCard__Tz84A,
  .Dashboard_infoCard__yM6ta {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.module.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,mCAAmC;AACnC;EACE,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,4CAA4C;EAC5C,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;iDAEiD;AACjD;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;EACpB,wBAAwB;EACxB,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,mDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;iDAEiD;AACjD;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;EACT,qBAAqB;EACrB,0EAA0E;EAC1E,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2DAA2D;IAC3D,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,SAAO;IACP,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,sCAAsC;IACtC,qCAAqC;EACvC;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,mBAAmB;IACnB,wBAAwB;EAC1B;AACF","sourcesContent":["/* ============================================\n   Dashboard - Enterprise Corporate Design\n   ============================================ */\n\n/* CSS Variables - Matching Theme */\n:root {\n  --dashboard-bg: #f8f9fa;\n  --dashboard-text: #000000;\n  --dashboard-text-muted: #4a5568;\n  --dashboard-border: rgba(135, 206, 235, 0.3);\n  --light-sky-blue: #87ceeb;\n  --light-red: #ff6b6b;\n  --white: #ffffff;\n  --transition: all 0.2s ease;\n}\n\n/* ============================================\n   Main Dashboard Container\n   ============================================ */\n.dashboard {\n  min-height: calc(100vh - 60px);\n  background: var(--dashboard-bg);\n  padding: 1.5rem;\n  color: var(--dashboard-text);\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n/* ============================================\n   Dashboard Header\n   ============================================ */\n.dashboardHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.dashboardTitle {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--dashboard-text);\n  margin: 0;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.timeDisplay {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--dashboard-text-muted);\n  padding: 0.5rem 1rem;\n  background: var(--white);\n  border: 1px solid var(--dashboard-border);\n  border-radius: 0.375rem;\n}\n\n.timeDisplay svg {\n  color: var(--light-sky-blue);\n  flex-shrink: 0;\n}\n\n/* ============================================\n   Error Alert\n   ============================================ */\n.errorAlert {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: var(--light-red);\n  color: white;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.errorAlert svg {\n  flex-shrink: 0;\n}\n\n/* ============================================\n   Loading Container\n   ============================================ */\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.spinner {\n  color: var(--light-sky-blue);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ============================================\n   Metrics Grid\n   ============================================ */\n.metricsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.metricCard {\n  background: var(--white);\n  border: 1px solid var(--dashboard-border);\n  border-radius: 0.5rem;\n  padding: 1.25rem;\n  transition: var(--transition);\n}\n\n.metricCard:hover {\n  border-color: var(--light-sky-blue);\n  transform: translateY(-2px);\n}\n\n.metricCardClickable {\n  cursor: pointer;\n}\n\n.metricCardClickable:hover {\n  box-shadow: 0 4px 12px rgba(135, 206, 235, 0.25);\n}\n\n.metricCardClickable:focus-visible {\n  outline: 2px solid var(--light-sky-blue);\n  outline-offset: 2px;\n}\n\n.metricContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.metricInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  flex: 1;\n}\n\n.metricLabel {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--dashboard-text-muted);\n}\n\n.metricValue {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--dashboard-text);\n  line-height: 1.2;\n}\n\n.metricIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: rgba(135, 206, 235, 0.1);\n  color: var(--light-sky-blue);\n}\n\n/* ============================================\n   Top Cards Container (Activity Log & Upcoming Draws)\n   ============================================ */\n.topCardsContainer {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n/* ============================================\n   Player Status Container (Full Width)\n   ============================================ */\n.playerStatusContainer {\n  width: 100%;\n  margin-bottom: 1.5rem;\n}\n\n/* ============================================\n   Info Grid\n   ============================================ */\n.infoGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.infoCard {\n  background: var(--white);\n  border: 1px solid var(--dashboard-border);\n  border-radius: 0.5rem;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  transition: var(--transition);\n  flex: 1;\n  min-width: 300px;\n  overflow: hidden;\n}\n\n.infoCardFullWidth {\n  width: 100%;\n  min-width: 100%;\n}\n\n.infoCard:hover {\n  border-color: var(--light-sky-blue);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.infoCardTitle {\n  font-size: 1rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin: 0;\n  padding: 1rem 1.25rem;\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: none;\n}\n\n.infoCardIcon {\n  flex-shrink: 0;\n  color: #ffffff;\n  opacity: 0.9;\n}\n\n.infoCardTitleBlack {\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  color: #ffffff;\n}\n\n.infoCardTitleNavy {\n  background: linear-gradient(135deg, #001f3f 0%, #000000 50%, #001f3f 100%);\n  color: #ffffff;\n}\n\n.infoCardContent {\n  padding: 1.25rem;\n}\n\n/* ============================================\n   Activity Log\n   ============================================ */\n.activityList {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.activityRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-transform: uppercase;\n}\n\n.activityLabel {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--dashboard-text-muted);\n}\n\n.activityValue {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: var(--dashboard-text);\n}\n\n/* ============================================\n   Upcoming Draws\n   ============================================ */\n.drawsList {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.drawRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid var(--dashboard-border);\n}\n\n.drawRow:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.drawInfo {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex: 1;\n}\n\n.drawGameName {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--dashboard-text);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.drawSeparator {\n  color: var(--dashboard-text);\n  font-weight: 400;\n}\n\n.drawId {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #000000;\n  background: rgba(0, 255, 0, 0.3);\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  display: inline-block;\n}\n\n.drawTime {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--dashboard-text);\n}\n\n.emptyState {\n  font-size: 0.875rem;\n  color: var(--dashboard-text-muted);\n  text-align: center;\n  padding: 1rem 0;\n}\n\n/* ============================================\n   Player Status\n   ============================================ */\n.playerStatus {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.totalPlayers {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.totalLabel {\n  font-size: 0.875rem;\n  color: var(--dashboard-text-muted);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.totalValue {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--dashboard-text);\n  line-height: 1.2;\n}\n\n.statusList {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.statusRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 0;\n  font-size: 0.875rem;\n}\n\n.statusLabel {\n  color: var(--dashboard-text);\n  font-weight: 500;\n}\n\n.statusValue {\n  font-weight: 700;\n  color: var(--dashboard-text);\n}\n\n.breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding-top: 0.75rem;\n  margin-top: 0.75rem;\n}\n\n.breakdownDivider {\n  height: 1px;\n  background: var(--dashboard-border);\n}\n\n.breakdownTitle {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--dashboard-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* ============================================\n   Responsive Design - Tablet\n   ============================================ */\n@media (max-width: 1024px) {\n  .dashboard {\n    padding: 1.25rem;\n  }\n\n  .dashboardTitle {\n    font-size: 1.25rem;\n  }\n\n  .metricsGrid {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 0.875rem;\n  }\n\n  .topCardsContainer {\n    flex-direction: column;\n    gap: 0.875rem;\n  }\n\n  .infoCard {\n    min-width: 100%;\n  }\n\n  .totalValue {\n    font-size: 1.75rem;\n  }\n\n  .metricValue {\n    font-size: 1.75rem;\n  }\n}\n\n/* ============================================\n   Responsive Design - Mobile\n   ============================================ */\n@media (max-width: 768px) {\n  .dashboard {\n    padding: 1rem;\n    min-height: calc(100vh - 50px);\n  }\n\n  .dashboardHeader {\n    margin-bottom: 1.25rem;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.75rem;\n  }\n\n  .dashboardTitle {\n    font-size: 1.125rem;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .timeDisplay {\n    font-size: 0.875rem;\n    padding: 0.375rem 0.75rem;\n    flex-shrink: 0;\n    white-space: nowrap;\n  }\n\n  .metricsGrid {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n    margin-bottom: 1.25rem;\n  }\n\n  .topCardsContainer {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .playerStatusContainer {\n    width: 100%;\n  }\n\n  .totalValue {\n    font-size: 1.5rem;\n  }\n\n  .metricCard {\n    padding: 1rem;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .infoCard {\n    padding: 1rem;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .metricValue {\n    font-size: 1.5rem;\n  }\n\n  .totalValue {\n    font-size: 1.75rem;\n  }\n\n  .drawRow {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .drawTime {\n    width: 100%;\n    text-align: right;\n  }\n}\n\n/* ============================================\n   Responsive Design - Small Mobile\n   ============================================ */\n@media (max-width: 480px) {\n  .dashboard {\n    padding: 0.75rem;\n    min-height: calc(100vh - 48px);\n  }\n\n  .dashboardHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .dashboardTitle {\n    font-size: 1rem;\n    width: 100%;\n  }\n\n  .timeDisplay {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .metricCard {\n    padding: 0.875rem;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .metricContent {\n    flex-wrap: wrap;\n    gap: 0.75rem;\n  }\n\n  .metricIcon {\n    width: 48px;\n    height: 48px;\n  }\n\n  .metricIcon svg {\n    width: 24px;\n    height: 24px;\n  }\n\n  .metricValue {\n    font-size: 1.375rem;\n  }\n\n  .infoCard {\n    padding: 0.875rem;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .infoCardTitle {\n    font-size: 0.875rem;\n  }\n\n  .drawGameName {\n    font-size: 0.875rem;\n  }\n\n  .drawTime {\n    font-size: 0.875rem;\n  }\n\n  .totalValue {\n    font-size: 1.5rem;\n  }\n\n  .drawRow {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .drawTime {\n    width: 100%;\n    text-align: left;\n  }\n}\n\n/* ============================================\n   Accessibility\n   ============================================ */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition-duration: 0.01ms !important;\n    animation-duration: 0.01ms !important;\n  }\n}\n\n/* Print styles */\n@media print {\n  .dashboard {\n    background: white;\n  }\n\n  .metricCard,\n  .infoCard {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `Dashboard_dashboard__RDdb6`,
	"dashboardHeader": `Dashboard_dashboardHeader__zb7AE`,
	"dashboardTitle": `Dashboard_dashboardTitle__BDJEW`,
	"timeDisplay": `Dashboard_timeDisplay__EYu7z`,
	"errorAlert": `Dashboard_errorAlert__iIXGN`,
	"loadingContainer": `Dashboard_loadingContainer__ss+Te`,
	"spinner": `Dashboard_spinner__bdpNT`,
	"spin": `Dashboard_spin__gW-XO`,
	"metricsGrid": `Dashboard_metricsGrid__nDn+t`,
	"metricCard": `Dashboard_metricCard__Tz84A`,
	"metricCardClickable": `Dashboard_metricCardClickable__Qi503`,
	"metricContent": `Dashboard_metricContent__ONC4m`,
	"metricInfo": `Dashboard_metricInfo__PoTXc`,
	"metricLabel": `Dashboard_metricLabel__2hG1u`,
	"metricValue": `Dashboard_metricValue__oODCO`,
	"metricIcon": `Dashboard_metricIcon__leoQq`,
	"topCardsContainer": `Dashboard_topCardsContainer__bZdVl`,
	"playerStatusContainer": `Dashboard_playerStatusContainer__D03Oz`,
	"infoGrid": `Dashboard_infoGrid__BaEMr`,
	"infoCard": `Dashboard_infoCard__yM6ta`,
	"infoCardFullWidth": `Dashboard_infoCardFullWidth__-zSsL`,
	"infoCardTitle": `Dashboard_infoCardTitle__7VdQr`,
	"infoCardIcon": `Dashboard_infoCardIcon__hMSmu`,
	"infoCardTitleBlack": `Dashboard_infoCardTitleBlack__R7uw8`,
	"infoCardTitleNavy": `Dashboard_infoCardTitleNavy__FspgZ`,
	"infoCardContent": `Dashboard_infoCardContent__oIJNv`,
	"activityList": `Dashboard_activityList__lhNy7`,
	"activityRow": `Dashboard_activityRow__SJkzP`,
	"activityLabel": `Dashboard_activityLabel__dP-Z-`,
	"activityValue": `Dashboard_activityValue__MaCVD`,
	"drawsList": `Dashboard_drawsList__g9Pp5`,
	"drawRow": `Dashboard_drawRow__Ru+bF`,
	"drawInfo": `Dashboard_drawInfo__FgwbD`,
	"drawGameName": `Dashboard_drawGameName__9yLmy`,
	"drawSeparator": `Dashboard_drawSeparator__jvbBF`,
	"drawId": `Dashboard_drawId__DjYWM`,
	"drawTime": `Dashboard_drawTime__1bL9A`,
	"emptyState": `Dashboard_emptyState__4Z9zs`,
	"playerStatus": `Dashboard_playerStatus__9Iyxs`,
	"totalPlayers": `Dashboard_totalPlayers__DGtTw`,
	"totalLabel": `Dashboard_totalLabel__pwYiN`,
	"totalValue": `Dashboard_totalValue__2L7gP`,
	"statusList": `Dashboard_statusList__qf4yt`,
	"statusRow": `Dashboard_statusRow__gGU6l`,
	"statusLabel": `Dashboard_statusLabel__kvkVW`,
	"statusValue": `Dashboard_statusValue__ilYsS`,
	"breakdown": `Dashboard_breakdown__B9PZr`,
	"breakdownDivider": `Dashboard_breakdownDivider__HdUad`,
	"breakdownTitle": `Dashboard_breakdownTitle__dgql3`
};
export default ___CSS_LOADER_EXPORT___;
